<div style="display: block;height: 350px;">
    <app-highcharts chartTitle="Ping de VPN (ms)" [data$]="dataSubject" height="300" valueSuffix=" ms"></app-highcharts>
</div>
